import { Skeleton } from '@/components/ui/skeleton'
import { CardGrid } from './card-grid'

/** Loading placeholder matching the ContentCard grid layout. */
export function CardGridSkeleton({ count = 6, className }: { count?: number; className?: string }) {
  return (
    <CardGrid className={className}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="overflow-hidden rounded-xl border">
          <Skeleton className="aspect-video w-full rounded-none" />
          <div className="space-y-2 p-4">
            <Skeleton className="h-3 w-1/3" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-full" />
          </div>
        </div>
      ))}
    </CardGrid>
  )
}
